"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.soundPressureLevel = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const VariableName_1 = require("../VariableName");
exports.soundPressureLevel = {
    __basic_data_type: true,
    __slotted_variable_name_data_type: true,
    __variable_name_data_type: true,
    id: 'soundPressureLevel',
    variableName: VariableName_1.VariableName.soundPressureLevel,
    title: 'Sound pressure',
    icon: free_solid_svg_icons_1.faVolumeUp,
    isSlotted: true,
    order: 8,
    graphQLSampleKey: 'sound',
    bucketing: {
        min: 0,
        max: 8000,
        numberOfBuckets: 6,
    },
    colormap: [
        { value: 0.0 * 8000, rgb: [0, 255, 0, 1] },
        { value: 0.4 * 8000, rgb: [0, 255, 0, 1] },
        { value: 0.6 * 8000, rgb: [255, 204, 0, 1] },
        { value: 0.8 * 8000, rgb: [255, 0, 0, 1] },
        { value: 1.0 * 8000, rgb: [255, 0, 0, 1] },
    ],
    dataPointConverter: x => x / 100,
    unit: 'dBA',
    decimals: 1,
};
//# sourceMappingURL=sound-pressure-level.js.map